import { FiBarChart2 } from "react-icons/fi";
import { Link } from "react-router-dom";
import { navigationLinks } from "../../assets/constances";
import MobileNavigationLinks from "./MobileNavigationLinks";
import Logo from "./Logo";
import { useState } from "react";
import SocialMedia from "../SocialMedia";

export default function Appbar() {
  const [isOpen, setIsOpen] = useState(false);
  const toggleMenu = () => setIsOpen(!isOpen);
  return (
    <nav className="bg-darkblue text-white flex items-center justify-between sticky left-0 top-0 z-40 md:px-[5%] w-full md:p-0 px-4">
      <Logo />
      <div className="md:block hidden">
        <ul className="flex">
          {navigationLinks.map((link) => (
            <li className="">
              <Link
                className="h-[4rem] px-5 flex items-center border-b-4 border-darkblue hover:border-darkorange hover:text-darkorange"
                to={link.path}
              >
                {link.text}
              </Link>
            </li>
          ))}
        </ul>
      </div>
      <MobileNavigationLinks isOpen={isOpen} toggleMenu={toggleMenu} />
      <SocialMedia />
      <span className="md:hidden block text-2xl" onClick={toggleMenu}>
        <FiBarChart2 className="-rotate-90" />
      </span>
    </nav>
  );
}

export function Icon({ icon, cName = "md:text-2xl text-xl md:ml-6" }) {
  return <span className={`${cName} hover:text-darkorange`}>{icon}</span>;
}
